/**
 * AP-38-B — Für welche Firma (welchen Mandanten) **dieser Browser-Tab** arbeitet.
 *
 * Die Sitzung gehört der Person, nicht der Firma: Das Refresh-Cookie ist für alle
 * Tabs dasselbe. Welcher Mandant beim Erneuern des Zugriffstokens gilt, sagt
 * deshalb der Tab selbst — er schickt die hier gemerkte Firma mit. So arbeiten
 * zwei Tabs in zwei Firmen nebeneinander, ohne dass einer die Daten des anderen
 * bekommt.
 *
 * Bewusst `sessionStorage`, nicht `localStorage`: Er gilt je Tab und überlebt
 * das Neuladen. Ein neuer Tab startet ohne Wahl und bekommt die zuletzt gewählte
 * Firma der Person (`Identity.lastTenantId`).
 *
 * Alle Zugriffe sind in try/catch: In manchen Umgebungen (privates Fenster,
 * gesperrter Speicher) wirft schon der Zugriff. Dann gilt eben keine Wahl.
 */

const SCHLUESSEL = 'symphenia.firma'

export function gewaehlteFirma(): string | null {
  try {
    return sessionStorage.getItem(SCHLUESSEL)
  } catch {
    return null
  }
}

export function merkeFirma(tenantId: string): void {
  try {
    sessionStorage.setItem(SCHLUESSEL, tenantId)
  } catch {
    // ohne Speicher keine Wahl — der Server nimmt die zuletzt gewählte Firma
  }
}

export function vergissFirma(): void {
  try {
    sessionStorage.removeItem(SCHLUESSEL)
  } catch {
    // nichts zu vergessen
  }
}
